module.exports = __webpack_public_path__ + "static/media/buy_payment_4.ae19377d.jpg";